import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5663f330&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5663f330')) {
      api.createRecord('5663f330', component.options)
    } else {
      api.reload('5663f330', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5663f330&", function () {
      api.rerender('5663f330', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/App/VSL/MyContainerDeliveryOrder/index.vue"
export default component.exports